<template>
    <div class="main">
        <el-dialog
            title="修改服务区域"
            :visible.sync="openData.state"
            :close-on-click-modal="false"
            width="700px"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <div class="content">
                <el-tree
                    class="treeStyle"
                    :data="treeData"
                    show-checkbox
                    default-expand-all
                    :default-checked-keys="checkIds"
                    node-key="id"
                    ref="tree"
                    highlight-current
                    :props="defaultProps"
                >
                </el-tree>
            </div>
            <div slot="footer" class="dialog-footer dialog-footer-btn">
                <el-button type="primary" @click="handleSubmit"
                    >确 定</el-button
                >
                <el-button @click="dialogVisibleClone">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ["openData"],
    data() {
        return {
            treeData: [],
            checkIds: [],
            defaultProps: {
                children: "children",
                label: "address",
            },
        }
    },
    created() {
        this.getData()
    },
    methods: {
        // 获取数据
        getData() {
            this.$http
                .request({
                    url:
                        "/ypt/admin/serviceStation/info/findAddressServestation",
                    method: "POST",
                    data: { serviceStationId: this.openData.id },
                })
                .then((res) => {
                    if (res.code == 200) {
                        res.content.forEach((item) => {
                            this.checkIds.push(item.standardAddressId)
                        })

                        this.getTree()
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        // 获取树
        getTree() {
            this.$http
                .request({
                    url: "/ypt/admin/standardAddress/info/StandardAddressTree",
                    method: "POST",
                    data: {},
                })
                .then((res) => {
                    this.treeData = res.content

                    this.$nextTick(() => {
                        this.$refs.tree.setCheckedKeys(this.checkIds)
                    })
                })
        },

        // 关闭
        dialogVisibleClone() {
            this.$emit("cancleChoose", false)
        },
        // 提交
        handleSubmit() {
            this.$http
                .request({
                    url:
                        "/ypt/admin/serviceStation/info/saveAddressServestation",
                    method: "POST",
                    data: {
                        serviceStationId: this.openData.id,
                        standardAddressIds: this.$refs.tree.getCheckedKeys(),
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.$message.success(res.message)
                        this.$emit("cancleChoose", true)
                        this.$refs.tree.setCheckedKeys([])
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
    },
}
</script>
<style lang="less" scoped>
.content {
    height: 300px;
}
.treeStyle {
    height: 300px;
    overflow-y: auto;
}
</style>